<div class="card">
  <div class="card-header d-flex justify-content-between align-items-center">
    <div class="col-12 justify-content-between align-items-center d-flex">
      <h3 class="card-title mb-0">{{ config?.cardTitle }}</h3>
      <custom-button [config]="config?.editItemButton" />
    </div>
    <div class="col d-flex justify-content-end"></div>
  </div>
  <div class="card-body">
    <data-list [config]="config?.dataList" />
  </div>
  <div class="card-footer">
    <div class="col-12 d-flex justify-content-center my-2">
      <button
        type="button"
        class="btn btn-primary me-4 px-4 py-2"
        (click)="goBack()"
      >
        Back
      </button>
    </div>
  </div>
</div>
